import { render, staticRenderFns } from "./doorTags.vue?vue&type=template&id=9ef96074"
import script from "./doorTags.vue?vue&type=script&lang=js"
export * from "./doorTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports